import React from 'react';
import styled from 'styled-components';
import { Link } from 'components/Common';
import SearchiOSIcon from 'icons/search-ios.svg';
import SearchAndroidIcon from 'icons/search-android.svg';
import { isiOS } from 'config';

const SearchImg = styled.img`
  margin-right: 20px;
  vertical-align: ${isiOS ? 'sub' : 'middle'};
  height: 20px;
`;

const SearchButton = ({ type, pageType }) => (
  <Link
    to={`/${type}/search`}
    pageDirection="FORWARD"
  >
    <SearchImg
      src={isiOS ? SearchiOSIcon : SearchAndroidIcon}
      alt="Search"
      id="search-icon"
    />
  </Link>
);

export default SearchButton;
